import { Link } from "@tanstack/react-router";
import type { CSSProperties } from "react";

import { PremiumUpgradePopover } from "#/components/PremiumUpgradePopover";
import { Button } from "#/components/ui/button";
import { mapAccessUiFlags, type AccessResult } from "#/lib/mapAccessUi";
import { isMapAccessUpsellReason, MAP_ACCESS_UPSELL_COPY } from "#/lib/mapAccessUpsellCopy";
import { cn } from "#/lib/utils";

export function PlayMapCta({
  mapId,
  access,
  label = "Play →",
  className,
  style,
}: {
  mapId: string;
  access: AccessResult;
  label?: string;
  className?: string;
  style?: CSSProperties;
}) {
  const { canPlay, isUpgradeLocked } = mapAccessUiFlags(access);
  const buttonClassName = cn("mx-auto h-11 w-full text-base font-semibold shadow-md", className);

  if (canPlay) {
    return (
      <Button
        size="lg"
        className={buttonClassName}
        style={style}
        render={<Link to="/play/$mapId" params={{ mapId }} preload={false} />}
        nativeButton={false}
      >
        {label}
      </Button>
    );
  }

  if (isUpgradeLocked && !access.ok && isMapAccessUpsellReason(access.reason)) {
    return (
      <PremiumUpgradePopover
        triggerLabel={label}
        description={MAP_ACCESS_UPSELL_COPY[access.reason].description}
        className={buttonClassName}
        style={style}
      />
    );
  }

  return <p className="w-full text-center text-sm text-muted-foreground">Not yet released</p>;
}
